import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { a as extractElementsFromSlot } from './slot-utils.js';
import { d as defineCustomElement$2 } from './auto-grid.js';

const videoSelectorCss = ".picker-enclosure{display:flex;flex-direction:column;row-gap:var(--tt-spacing-md)}";

const VideoSelector = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.ttChange = createEvent(this, "tt-change", 7);
    this.selectedVideos = new Set();
    this.active = true;
    this.selected = '';
  }
  connectedCallback() {
    this.handleActiveChange = this.handleActiveChange.bind(this);
    this.handleSelectionChange = this.handleSelectionChange.bind(this);
    this.handleSelectedChange = this.handleSelectedChange.bind(this);
    this.updateSelection = this.updateSelection.bind(this);
  }
  componentDidLoad() {
    this.handleSelectedChange(this.selected);
  }
  handleSelectionChange(event) {
    const videoCard = event.target;
    if (videoCard.tagName.toLowerCase() === 'tt-video-card') {
      if (videoCard.selected) {
        this.selectedVideos.add(videoCard.videoId);
      }
      else {
        this.selectedVideos.delete(videoCard.videoId);
      }
      this.ttChange.emit({ selectedVideos: [...this.selectedVideos].join(',') });
    }
  }
  handleActiveChange() {
    this.updateSelection();
  }
  handleSelectedChange(newSelection) {
    const newSelectionIds = newSelection.split(',').filter((id) => id.length > 0);
    this.selectedVideos = new Set(newSelectionIds);
    this.updateSelection();
  }
  updateSelection() {
    if (!this.videoSlot)
      return;
    const videoCards = extractElementsFromSlot(this.videoSlot, 'tt-video-card');
    videoCards.forEach((vc) => {
      vc.selectable = this.active;
      vc.selected = this.selectedVideos.has(vc.videoId);
    });
  }
  render() {
    return (h("div", { class: "selector-enclosure" }, h("slot", { name: "search-bar" }), h("tt-auto-grid", { "grid-gap": "16px", "min-item-width": "225px" }, h("slot", { ref: (el) => (this.videoSlot = el), onSlotchange: () => this.updateSelection() }))));
  }
  static get watchers() { return {
    "active": ["handleActiveChange"],
    "selected": ["handleSelectedChange"]
  }; }
  static get style() { return videoSelectorCss; }
}, [1, "tt-video-selector", {
    "active": [4],
    "selected": [1]
  }, [[0, "tt-selection-change", "handleSelectionChange"]]]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-video-selector", "tt-auto-grid"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-video-selector":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, VideoSelector);
      }
      break;
    case "tt-auto-grid":
      if (!customElements.get(tagName)) {
        defineCustomElement$2();
      }
      break;
  } });
}

const TtVideoSelector = VideoSelector;
const defineCustomElement = defineCustomElement$1;

export { TtVideoSelector, defineCustomElement };
